/* src/app/private/components/packages/assign-package/assign-package.component.scss */
.assign-package-dialog .p-dialog-header {
  font-size: 1.25rem;
  font-weight: 600;
  padding-bottom: 0.5rem;
}
.assign-package-dialog .formgrid .field {
  margin-bottom: 1rem;
}
.assign-package-dialog textarea {
  resize: none;
}
/*# sourceMappingURL=assign-package.component.css.map */
